import * as _ from "lodash";

export class AclHandler {
  constructor(user, isCloudMode) {
    const safeUser = _.isObject(user) ? user : {};

    this.isCloudMode = isCloudMode;

    this.aclSource = {
      locations: Array.isArray(safeUser.locations) ? safeUser.locations : [],
      grants: Array.isArray(safeUser.grants) ? safeUser.grants : []
    };
  }

  //
  // проверяет есть ли доступ к DEFAULT локации
  //
  hasDefaultLocation() {
    return _.some(this.aclSource.locations, (location) => location.code === 'DEFAULT');
  }

  //
  // проверяет есть ли необходимая роль
  //
  // roleCode - код роли
  //
  hasRole(roleCode) {
    return this.aclSource.grants.map(g => g.role.code).includes(roleCode);
  }

  //
  // проверяет есть ли необходимые гранты на операцию для компонента
  //
  // componentCode - код компонента
  // operationCode - код операции
  //
  hasGrantForOperation(componentCode, operationCode) {
    const aclList = _.flatten(this.aclSource.grants.map(g => g.role.acls));
    return _.some(aclList, function(acl) {
      return acl.componentOperation.component.code == componentCode && acl.componentOperation.operation.code == operationCode
    });
  }

  //
  // возвращает признак наличия необходимых прав
  //
  // permission - разрешение, которое необходимо проверить
  //
  hasPermission(permission) {

    let result = true;

    if(permission.roleCodes != undefined){
      result = result && _.some(permission.roleCodes, (role) => this.hasRole(role));
    }

    if(permission.componentCode != undefined && permission.operationCode != undefined){
      result = result && this.hasGrantForOperation(permission.componentCode, permission.operationCode);
    }

    return result;
  }
}